import React from 'react';
import { Input } from 'reactstrap';

export default function BreakoutSelect({
  availableBreakouts = [],
  selectedBreakoutId = null,
  onBreakoutChange = () => {},
  className = 'limited-width-auto dark',
}) {
  if (availableBreakouts.length <= 1) {
    return null;
  }

  return (
    <div>
      <label>Breakout</label>
      <Input
        type="select"
        bsSize="sm"
        className={className}
        value={selectedBreakoutId ?? ''}
        onChange={(e) => onBreakoutChange(e.target.value || null)}
        style={{ minWidth: '12rem' }}
      >
        {availableBreakouts.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name}
          </option>
        ))}
      </Input>
    </div>
  );
}
